import type { ReaderTag } from '@/api/client';
import { ReaderCatalogTagPill } from '@/components/ReadersTable/ReaderCatalogTagPill';
import { CatalogTagsMoreBadge } from './CatalogTagsMoreBadge';
import type { CatalogTagsInlineFitResult } from './computeCatalogTagsInlineFit';
import './CatalogTagsInlineBadgesRow.css';

export interface CatalogTagsInlineBadgesRowProps {
  tags: ReaderTag[];
  fit: CatalogTagsInlineFitResult;
  disabled?: boolean;
  onClick?: () => void;
  containerRef: React.RefObject<HTMLButtonElement | null>;
}

function renderPill(
  tag: ReaderTag,
  truncate: boolean,
  lastTagMaxWidth: number | undefined
) {
  return (
    <ReaderCatalogTagPill
      key={tag.id}
      tag={tag}
      className={
        truncate
          ? 'catalog-tags-inline-badges-row__pill catalog-tags-inline-badges-row__pill_last'
          : 'catalog-tags-inline-badges-row__pill'
      }
      style={truncate && lastTagMaxWidth != null ? { maxWidth: lastTagMaxWidth } : undefined}
    />
  );
}

export function CatalogTagsInlineBadgesRow({
  tags,
  fit,
  disabled = false,
  onClick,
  containerRef,
}: CatalogTagsInlineBadgesRowProps) {
  const { visibleCount, row1Count, showMore, hiddenCount, lastTagMaxWidth } = fit;
  const visible = tags.slice(0, visibleCount);
  const row1 = visible.slice(0, row1Count);
  const row2 = visible.slice(row1Count);
  const lastRow2Index = row2.length - 1;

  const title = tags.map((t) => t.name).join(', ');

  const showRow2 = row2.length > 0 || (showMore && hiddenCount > 0);

  return (
    <button
      ref={containerRef as React.Ref<HTMLButtonElement>}
      type="button"
      className="catalog-tags-inline-badges-row readers-table-catalog__tags-cell"
      disabled={disabled}
      title={title}
      aria-label={`Теги: ${title}. Нажмите, чтобы открыть список`}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
    >
      {row1.length > 0 ? (
        <div className="catalog-tags-inline-badges-row__line">
          {row1.map((t) => renderPill(t, false, undefined))}
        </div>
      ) : null}
      {showRow2 ? (
        <div className="catalog-tags-inline-badges-row__line">
          {row2.map((t, i) =>
            renderPill(t, showMore && i === lastRow2Index, showMore && i === lastRow2Index ? lastTagMaxWidth : undefined)
          )}
          {showMore && hiddenCount > 0 ? <CatalogTagsMoreBadge hiddenCount={hiddenCount} /> : null}
        </div>
      ) : null}
    </button>
  );
}
